"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { createElement } from "react";
import TextLink from "../../../../navigation/TextLink/TextLink.js";
import Button from "../../../../buttons/Button/Button.js";
import { useTracking } from "../../../../../hooks/useTracking.js";
import Container from "../../../../layout/Container/Container.js";
import Group from "../../../../layout/Group/Group.js";
import LanguageSelector from "../../../../navigation/LanguageSelector/LanguageSelector.js";
import { Box } from "@mantine/core";
import { useWindowScroll } from "@mantine/hooks";
import '../../../../../assets/GlobalNavbar.css';const root = "_root_8obdn_2";
const container = "_container_8obdn_19";
const innerContainer = "_innerContainer_8obdn_24";
const left = "_left_8obdn_31";
const right = "_right_8obdn_35";
const register = "_register_8obdn_47";
const GlobalNavbarStyles = {
  root,
  container,
  innerContainer,
  left,
  right,
  register
};
const GlobalNavbar = (props) => {
  const {
    links,
    languages,
    register: register2,
    languagesPolymorphicProps,
    className,
    selectedSite,
    mod,
    style,
    ...rest
  } = props;
  const [scroll] = useWindowScroll();
  const tracker = useTracking();
  return /* @__PURE__ */ jsx(
    Box,
    {
      ...rest,
      className: `${GlobalNavbarStyles.root} ${className}`,
      mod: { scrolled: scroll.y >= 20, ...mod },
      visibleFrom: "lg",
      style,
      children: /* @__PURE__ */ jsx(Container, { className: GlobalNavbarStyles.container, size: "global", center: true, children: /* @__PURE__ */ jsxs(
        Group,
        {
          align: "center",
          spacing: "xl",
          justify: "center",
          className: GlobalNavbarStyles.innerContainer,
          scale: 0.875,
          children: [
            (links == null ? void 0 : links.length) && /* @__PURE__ */ jsx(Group, { className: GlobalNavbarStyles.left, children: links.map((link, index) => {
              var _a;
              return /* @__PURE__ */ createElement(
                TextLink,
                {
                  ...link,
                  variant: "component",
                  color: "light",
                  key: `globalLink${index}`,
                  selected: (_a = link.text) == null ? void 0 : _a.includes(selectedSite),
                  onClick: () => tracker == null ? void 0 : tracker.page.navigate({
                    type: "header",
                    action: link.text,
                    destination: link.href
                  }),
                  disablePolymorphic: true
                }
              );
            }) }),
            /* @__PURE__ */ jsxs(Group, { align: "center", spacing: "md", className: GlobalNavbarStyles.right, children: [
              register2 && /* @__PURE__ */ jsx(Box, { visibleFrom: "md", className: GlobalNavbarStyles.register, children: /* @__PURE__ */ jsx(
                Button,
                {
                  compact: true,
                  variant: "cta",
                  text: register2 == null ? void 0 : register2.text,
                  href: register2 == null ? void 0 : register2.href,
                  target: register2 == null ? void 0 : register2.target,
                  onClick: () => tracker == null ? void 0 : tracker.page.navigate({
                    type: "header",
                    action: register2 == null ? void 0 : register2.text,
                    destination: register2 == null ? void 0 : register2.href
                  })
                }
              ) }),
              languages && languages.length > 1 && /* @__PURE__ */ jsx(LanguageSelector, { items: languages, polymorphicProps: languagesPolymorphicProps })
            ] })
          ]
        }
      ) })
    }
  );
};
export {
  GlobalNavbar as default
};
